var _path, _path2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStorageBig = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 120,
  fill: "none",
  viewBox: "0 0 120 120"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 3,
  d: "M30 30h60v60H30z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 2,
  d: "M40 40h40v40H40z",
  opacity: 0.5
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 60,
  r: 12,
  stroke: "currentColor",
  strokeWidth: 3
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 60,
  r: 6,
  fill: "currentColor"
})));
export default SvgStorageBig;